import { ContentRowSkeleton } from "@dropbox/dash-component-library";
import { Badge } from "@dropbox/dig-components/badge";
import { Skeleton } from "@dropbox/dig-components/skeleton";
import { Box, Split } from "@dropbox/dig-foundations";
import { ActivityObject } from "./ActivityObject";
import { ActivityThumbnail } from "./ActivityThumbnail";
import styles from "./ExpandedActivityListItem.module.css";

import type { dash_feed, stacks, users } from "@dropbox/api-v2-client";
import { List } from "@dropbox/dig-components/list";
import type { LastViewedStackInfo } from "@mirage/service-recent-content/types";

type ActivityListItemProps = {
  activity: dash_feed.FeedItem;
  currentAccount?: users.FullAccount;
  index?: number;
  stackLastViewedInfo?: LastViewedStackInfo;
  companyStackInfo?: Record<string, stacks.PublishData>;
};

export const ExpandedActivityListItem = ({
  activity,
  currentAccount,
  index,
  stackLastViewedInfo,
  companyStackInfo,
}: ActivityListItemProps) => {
  const showBadge = !activity.is_read;
  return (
    <Box paddingY="Micro Medium" paddingLeft="Macro Small">
      <List.Content>
        <Split gap="Micro Large">
          <Split.Item>
            <Box position="relative">
              {showBadge && (
                <Badge
                  size="xsmall"
                  variant="attention"
                  className={styles.unreadBadge}
                />
              )}
              <ActivityThumbnail activity={activity} />
            </Box>
          </Split.Item>
          <Split.Item width="fill">
            <ActivityObject
              activity={activity}
              index={index}
              stackLastViewedInfo={stackLastViewedInfo}
              companyStackInfo={companyStackInfo}
              currentAccount={currentAccount}
            />
          </Split.Item>
        </Split>
      </List.Content>
    </Box>
  );
};

export const ExpandedActivityListItemSkeleton = () => {
  return (
    <Box paddingY="Micro Medium" paddingLeft="Macro Small">
      <List.Content>
        <Split gap="Micro Large">
          <Split.Item>
            <Box position="relative">
              <Skeleton.Avatar size="large" />
            </Box>
          </Split.Item>
          <Split.Item width="fill">
            <ContentRowSkeleton
              paddingSize="medium"
              startAccessorShape="square"
            />
          </Split.Item>
        </Split>
      </List.Content>
    </Box>
  );
};

ExpandedActivityListItem.Skeleton = ExpandedActivityListItemSkeleton;
